/*
 * AdvaHealth Solutions Pty. Ltd. ("AHS") CONFIDENTIAL
 * Copyright (c) 2025 AdvaHealth Solutions Pty. Ltd. All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of AHS. The intellectual and technical concepts contained
 * herein are proprietary to AHS and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from AHS.  Access to the source code contained herein is hereby forbidden to anyone except current AHS employees, managers or contractors who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of AHS. ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */

import { useLocation, useNavigationType } from "react-router-dom";
import React, { useEffect, useRef } from "react";
import useVersionCheck from "./useVersionCheck";
import { LayoutLocalStorage } from "../constant";

const NavigationInterceptor = ({
  children,
}: {
  children: React.ReactElement | React.ReactElement[];
}) => {
  const navigationType = useNavigationType(); // Type of the most recent navigation (PUSH/POP/REPLACE)
  const location = useLocation(); // Current route
  const shouldReload = useVersionCheck();
  // Read via a ref so a version poll result alone never triggers the effect below;
  // the reload must only happen when the user actually navigates.
  const shouldReloadRef = useRef(shouldReload);
  shouldReloadRef.current = shouldReload;

  useEffect(() => {
    if (shouldReloadRef.current && navigationType === "PUSH") {
      if (location.pathname === "/" || location.pathname === "/Worklist")
        return;
      // remove layout local storage when version changed.
      const values = Object.values(LayoutLocalStorage);
      values.forEach((v) => localStorage.removeItem(v));
      // Force reload with new code
      window.location.href =
        location.pathname + location.search + location.hash;
    }
  }, [location, navigationType]);

  return children;
};

export default NavigationInterceptor;
